import type { z } from 'zod'
import { zfd } from 'zod-form-data'

export type DialogParams = {
    channel: string
    message_id: string
    author_id: string
}

export const FormValuesSchema = zfd.formData({
    ban: zfd.checkbox(),
    report: zfd.checkbox(),
    deleteAll: zfd.checkbox(),
})

export type FormValues = z.infer<typeof FormValuesSchema>
